const React = require("react");
function IconStar(props) {
  return /*#__PURE__*/React.createElement("svg", Object.assign({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 24 24",
    fill: props.fill || "#232323",
    height: props.size || 24,
    size: props.size || 24,
    width: props.size || 24
  }, props), /*#__PURE__*/React.createElement("path", {
    d: "M6.41908 21.6356c-.33469.2756-.68413.2855-1.04835.0295-.36421-.2559-.47741-.5906-.3396-1.004l1.94903-6.3491-5.02023-3.6028c-.35437-.2559-.46757-.5857-.33961-.98927.12797-.40359.40851-.60538.84163-.60538h6.231l1.97855-6.6149q.08865-.32484.3396-.48726c.1674-.10827.3396-.16241.5168-.16241s.3495.05414.5168.16241q.25095.16242.3396.48726l1.9786 6.6149h6.231c.4331 0 .7136.20179.8416.60538.128.40357.0147.73337-.3396.98927l-5.0203 3.6028 1.9491 6.3491c.1378.4134.0246.7481-.3396 1.004-.3642.256-.7137.2461-1.0484-.0295l-5.1088-3.8981z"
  }));
}
module.exports = IconStar;